(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dYdX-connect-custom"] && !Shopify.designMode) return;
  try {
    
// Any custom JavaScript can be added here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

// Country configuration
const countries = [
  {
    name: 'Bangladesh',
    flag: 'https://flagcdn.com/w40/bd.png',
    url: 'https://www.thesunnah.store/'
  },
  {
    name: 'United Kingdom',
    flag: 'https://flagcdn.com/w40/gb.png',
    url: 'https://thesunnahstore.co.uk/'
  },
];

// Country Dropdown Functionality
class CountryDropdown {
  constructor() {
    this.dropdown = document.getElementById('country-dropdown');
    this.trigger = document.getElementById('country-trigger');
    this.menu = document.getElementById('country-menu');
    this.selectedFlag = document.getElementById('selected-flag');
    this.isOpen = false;
    
    if (this.dropdown && this.trigger && this.menu) {
      this.init();
    }
  }

  init() {
    this.populateDropdown();
    this.bindEvents();
    this.loadSavedCountry();
  }

  populateDropdown() {
    if (!this.menu) return;

    this.menu.innerHTML = countries.map(country => `
      <a href="${country.url}" class="country-dropdown__option" data-country="${country.code}">
        <div class="country-dropdown__option-flag">
          <img src="${country.flag}" alt="${country.name} flag">
        </div>
        <div class="country-dropdown__option-info">
          <span class="country-dropdown__option-name">${country.name}</span>
        </div>
      </a>
    `).join('');
  }

  bindEvents() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    document.addEventListener('click', (e) => {
      if (!this.dropdown.contains(e.target)) {
        this.close();
      }
    });

    this.menu.addEventListener('click', (e) => {
      const option = e.target.closest('.country-dropdown__option');
      if (option) {
        e.preventDefault();
        const country = option.dataset.country;
        const flag = option.querySelector('img').src;
        const name = option.querySelector('.country-dropdown__option-name').textContent;
        
        this.selectCountry(country, flag, name);
        window.location.href = option.href;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.dropdown.classList.add('active');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
  }

  close() {
    this.dropdown.classList.remove('active');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.isOpen = false;
  }

  selectCountry(countryCode, flagSrc, countryName) {
    if (this.selectedFlag && flagSrc) {
      this.selectedFlag.src = flagSrc;
      this.selectedFlag.alt = `${countryName} flag`;
    }

    try {
      localStorage.setItem('selected_country', JSON.stringify({
        code: countryCode,
        flag: flagSrc,
        name: countryName
      }));
    } catch (error) {
      console.log('Unable to save country preference');
    }

    const options = this.menu.querySelectorAll('.country-dropdown__option');
    options.forEach(opt => opt.classList.remove('active'));
    
    const selectedOption = this.menu.querySelector(`[data-country="${countryCode}"]`);
    if (selectedOption) {
      selectedOption.classList.add('active');
    }

    this.close();
  }

  loadSavedCountry() {
    try {
      const saved = localStorage.getItem('selected_country');
      if (saved) {
        const country = JSON.parse(saved);
        const countryExists = countries.find(c => c.code === country.code);
        if (countryExists) {
          this.selectCountry(country.code, country.flag, country.name);
        }
      }
    } catch (error) {
      console.log('No saved country preference');
    }
  }
}

// Mega menu hover functionality
document.addEventListener("DOMContentLoaded", function () {
  new CountryDropdown();

  const menuItems = document.querySelectorAll(".mega-menu");
  menuItems.forEach((menu) => {
    menu.addEventListener("mouseenter", function () {
      menu.setAttribute("open", "true");
    });

    menu.addEventListener("mouseleave", function () {
      menu.removeAttribute("open");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
